import { render } from "./SidebarCategoriesItem.vue?vue&type=template&id=b481c108&scoped=true"
import script from "./SidebarCategoriesItem.vue?vue&type=script&lang=js"
export * from "./SidebarCategoriesItem.vue?vue&type=script&lang=js"

import "./SidebarCategoriesItem.vue?vue&type=style&index=0&id=b481c108&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b481c108"]])

export default __exports__